import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import css from './IconCrafts.module.css';

const IconCrafts = props => {
  const { className, rootClassName } = props;
  const classes = clsx(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.6374 11.925C25.5308 12.2242 25.3652 12.4989 25.1505 12.733C24.9358 12.967 24.6763 13.1556 24.3874 13.2875C22.8499 13.9757 21.5437 15.0932 20.6257 16.5056C19.7077 17.9181 19.217 19.5655 19.2124 21.25C19.2136 21.8375 19.2724 22.4237 19.3874 23C19.4637 23.3522 19.4688 23.7162 19.4022 24.0704C19.3357 24.4247 19.1989 24.762 18.9999 25.0625C18.8315 25.3255 18.61 25.5503 18.3495 25.7226C18.089 25.8948 17.7953 26.0106 17.4874 26.0625C15.8363 26.3655 14.1384 26.2951 12.518 25.8565C10.8977 25.418 9.39598 24.6224 8.12307 23.5281C6.85015 22.4338 5.83827 21.0685 5.16158 19.5322C4.4849 17.996 4.16058 16.3278 4.21239 14.65C4.30941 11.841 5.44865 9.16869 7.40818 7.1537C9.36771 5.13871 12.0072 3.92535 14.8124 3.75H15.4499C17.5446 3.75053 19.5975 4.33586 21.3775 5.44008C23.1575 6.54431 24.5939 8.12356 25.5249 10C25.8114 10.5937 25.8519 11.2766 25.6374 11.9V11.925Z"
        stroke="#6E7191"
        strokeWidth="1.875"
      />
      <path
        d="M10 20.0128L10.0125 19.999"
        stroke="#6E7191"
        strokeWidth="1.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 15.0128L7.5125 14.999"
        stroke="#6E7191"
        strokeWidth="1.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 7.51277L15.0125 7.49902"
        stroke="#6E7191"
        strokeWidth="1.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 10.0128L20.0125 9.99902"
        stroke="#6E7191"
        strokeWidth="1.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const { string } = PropTypes;

IconCrafts.defaultProps = {
  className: null,
  rootClassName: null,
};

IconCrafts.propTypes = {
  className: string,
  rootClassName: string,
};

export default IconCrafts;
